import { render, staticRenderFns } from "./DetailAkun.vue?vue&type=template&id=2b972164&scoped=true&"
import script from "./DetailAkun.vue?vue&type=script&lang=js&"
export * from "./DetailAkun.vue?vue&type=script&lang=js&"
import style0 from "./DetailAkun.vue?vue&type=style&index=0&id=2b972164&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b972164",
  null
  
)

export default component.exports